module.exports = __webpack_public_path__ + "img/BlackStar_Region13Logo.2ed3658d.png";